import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';

export const ChevronIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.primary};
`;

export const Details = styled.details`
  &[open] ${ChevronIcon} {
    transform: rotateX(180deg);
  }
`;

export const Summary = styled.summary`
  align-items: center;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  list-style: none;

  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.mediumGrey};
    font-size: ${theme.fontSizes.p2};
    line-height: ${theme.fontSizes.h5};
    font-weight: ${theme.fontWeights.bold};
    padding: ${theme.spacing(2, 0)};
  `}

  &::-webkit-details-marker {
    display: none;
  }
`;

export const DetailsBody = styled.div`
  padding: ${({ theme }) => theme.spacing(1, 0)};
`;

export const FooterWrapper = styled.summary<{ $isEdge: boolean }>`
  ${({ theme, $isEdge }) => css`
    padding: ${$isEdge ? theme.spacing(2, 3, 5) : theme.spacing(2, 3)};

    ${theme.media.sm.up} {
      padding: 0;
    }
  `}
`;

export const ButtonsFooter = styled(Flex)`
  padding-top: ${({ theme }) => theme.spacing(1)};
`;
